import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

import security from "../../../services/security.js";
import auth from "../../../services/auth.js";
import events from "../../../services/events.js";
import companies from "../../../services/companies.js";

class PreferencesController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EventsService,
    ProfileService,
    CompaniesService,
    SecurityService,
    $rootScope,
    CommonService,
    EnvService,
    $timeout,
    $location,
    $scope
  ) {
    this.name = "preferences";
    $localStorage.activeStateName = "preferences";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$scope = $scope;
    this.$profile = ProfileService;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.$common = CommonService;
    this.pref_jobble_types = [];
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.remain_loading_count = 0;
    this.sections = {
      section_1: {is_clear: false},
      section_2: {is_clear: false},
      section_3: {is_clear: false},
    };
    this.ui_model = {
      error_model: {
        first_name: false,
        last_name: false,
        email: false,
        phone: false,
        ssn: false,
        address1: false,
        address2: false,
        city: false,
        state: false,
        zip_code: false,
        bio: false,
        dob: false,
        month: false,
        day: false,
        year: false,
      },
      warning_model: {email: false},
      submit_model: {
        form1: {is_disabled: true},
        form2: {is_disabled: true},
        form3: {is_disabled: true},
      },
    };
    this.loading = true;
    this.currentUser = this.$auth.getUserData();
    this.basicprofile_info = {
      basic: {
        personal_details: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          ssn: null,
          date_birth: {day: null, month: null, year: null},
          bio: null,
        },
        address: {
          street: null,
          apt: null,
          city: null,
          state: null,
          zip_code: null,
        },
        options: {
          preferred_jobble_types: [],
        },
        image: {
          url: null,
        },
      },
      extended: {},
    };

    //INIT FUNCTIONS
    this.getLatestUserData(this.$stateParams.basicprofileId);

    this.SetJobForApplicationAfterBasicFilledListener = this.$rootScope.$on("SetJobForApplicationAfterBasicFilled", ($event, params) => {
      this.job_from_board_during_apply_attempt = params.job;
    });

    this.UpdatePrefenceUIListener = this.$rootScope.$on("UpdatePrefenceUI", ($event, params) => {
      this.show_opt_out = params;
    });

    this.$scope.$on("$destroy", this.UpdatePrefenceUIListener);
    this.$scope.$on("$destroy", this.TriggerIndicatorDataListener);
    this.$scope.$on("$destroy", this.SetJobForApplicationAfterBasicFilledListener);
  }

  getLatestUserData(id) {
    var _this = this;
    if (_this.currentUser) {
      _this.$profile.validateUserByToken(_this.currentUser.access_token).then(
        function (response) {
          _this.setUserDataToView(response.data);
        },
        function (error) {}
      );
    } else {
      alert("we have no user....");
    }
  }

  getJobbleTypes(jobbleTypesParam, user) {
    var user_obj = user;

    const newFilters = [
      "Logistics",
      "Retail",
      "Warehouse",
      "Light Industrial",
      "Cashier",
      "Delivery",
      "Driver",
      "Stocking",
      "Facility Staff",
      "Restaurant",
      "Hospitality",
      "Housekeeping",
      "Landscaper",
      "Agriculture",
      "Caregiving",
      "Security",
      "Customer Service",
      "Event Staff",
    ];

    this.$auth.getJobbleTypes(200).then((data) => {
      this.jobbleTypes = data.data;

      if (data.data) {
        this.jobbleTypes = data.data.filter((type) => {
          return newFilters.indexOf(type.name) !== -1;
        });

        this.jobbleTypes = this.jobbleTypes.sort((a, b) => {
          return newFilters.indexOf(a.name) - newFilters.indexOf(b.name);
        });
      }

      this.jobble_types = this.jobbleTypes;
      this.$rootScope.jobble_types = this.jobbleTypes;
      this.setNotiJobbleTypes(jobbleTypesParam, user_obj);
    });
  }

  setUserDataToView(user) {
    this.getJobbleTypes(user.notifPref.jobbleTypes, user);
    this.currentUser = user;
    this.checkPolicy(user);
  }

  setNotiJobbleTypes(jobble_types, user) {
    var _this = this;

    var user_obj = user;

    if (jobble_types) {
      _this.display_pref_jt_warning = false;
      _this.sections.section_3.is_clear = true;
      try {
        jobble_types.forEach(function (j) {
          let jt = _this.jobble_types.find((o) => o.id === j.id);
          if (jt) {
            jt.selected = true;
            _this.pref_jobble_types.push(jt.id);
          }
        });
      } catch (err) {
        console.log("in error");
        console.dir(err);
      } finally {
        _this.checkToMakeSureAllFieldsAreFilledOut(user_obj);
        _this.$timeout(function () {
          _this.loading = undefined;
        }, 100);
      }
    } else {
      _this.display_pref_jt_warning = true;
      _this.checkToMakeSureAllFieldsAreFilledOut(user_obj);
      _this.$timeout(function () {
        _this.loading = undefined;
      }, 100);
    }
  }

  checkToMakeSureAllFieldsAreFilledOut(user) {
    var _this = this;
    if (
      _this.sections.section_1.is_clear === true &&
      _this.sections.section_2.is_clear === true &&
      _this.sections.section_3.is_clear === true &&
      _this.job_from_board_during_apply_attempt
    ) {
      let job = _this.job_from_board_during_apply_attempt;
      _this.$timeout(function () {
        _this.$state.go("jobblergallery", {
          job,
          display_warning: true,
        });
      }, 500);
    }
    if (
      _this.sections.section_1.is_clear &&
      _this.sections.section_2.is_clear &&
      _this.sections.section_3.is_clear &&
      user.filePROFILE_IMAGE1IMG_160x160
    ) {
      _this.status_clear = true;
    } else {
      _this.status_clear = false;
    }
  }

  handleResponse(response) {
    var _this = this;
    console.log("handleResponse response");
    console.dir(response);
    _this.$auth.validateUserByToken(_this.currentUser.access_token).then(
      function (r) {
        _this.$localStorage.logged_user = r.data;
        _this.currentUser = r.data;
        _this.set_current_user_to_parent(r.data);
        if (_this.job_from_board_during_apply_attempt) {
          _this.checkToMakeSureAllFieldsAreFilledOut(r.data);
        }
      },
      function (error) {
        console.log("error validating user");
        console.dir(error);
      }
    );
  }

  set_current_user_to_parent(user) {
    var _this = this;
    console.log("set_current_user_to_parent");
    console.dir(user);
    _this.$timeout(function () {
      _this.$rootScope.$emit("SettingNewUserDataToParent", user);
      _this.$rootScope.$emit("ProfileStatusCheck", _this.ui_model);
    });
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  togglePreferences() {
    this.expandPreferences = !this.expandPreferences;
  }

  changePrefJobbleTypes(type, index) {
    var _this = this;
    try {
      if (_this.pref_jobble_types.indexOf(type.id) > -1) {
        let i = _this.pref_jobble_types.indexOf(type.id);
        if (_this.pref_jobble_types.length > 1) {
          type.selected = false;
          _this.pref_jobble_types.splice(i, 1);
          _this.ui_model.submit_model.form3.is_disabled = false;
        } else {
          alert("You need atleast one preferred jobble type");
        }
      } else {
        _this.pref_jobble_types.push(type.id);
        _this.ui_model.submit_model.form3.is_disabled = false;
        type.selected = true;
      }
    } catch (err) {
      console.log("in error");
      console.dir(err);
    }
  }

  saveNotifPrefs() {
    var _this = this;

    if (_this.toggleModal) {
      _this.toggleModal();
    }

    if (_this.ui_model.submit_model.form3.is_disabled === false) {
      _this.setLoader();
    } else {
      return;
    }

    _this.display_pref_jt_warning = false;
    _this.$profile.updatePrefJobbleTypes(_this.pref_jobble_types).then(
      function (response) {
        if (window.toastr) {
          window.toastr.options.preventDuplicates = true;
          window.toastr.success("<i class=\"fas fa-check-circle\" style='margin-right: 8px'></i>Success! Your profile was updated");
        }

        _this.handleResponse(response.data);
        _this.ui_model.submit_model.form3.is_disabled = true;
        _this.jts_updated_successfully = true;
        _this.sections.section_3.is_clear = true;
        _this.$timeout(function () {
          _this.unSetLoader();
        }, 100);
        _this.$timeout(function () {
          _this.jts_updated_successfully = false;
        }, 4000);
      },
      function (error) {
        console.log("in error");
        console.dir(error);
      }
    );
  }

  optOut() {
    console.log("opt out");

    this.$timeout(function () {
      $("#opt-out").modal();
    }, 100);
  }

  checkPolicy(user) {
    console.log("checkPolicy");
    console.dir(user);
    if (user.acceptedPrivacyPolicy === true) {
      this.show_opt_out = true;
    } else {
      this.show_opt_out = false;
    }
  }

  optOut() {
    console.log("opt out");

    this.$timeout(function () {
      $("#opt-out").modal();
    }, 100);
  }

  optIn() {
    this.$timeout(function () {
      $("#opt-in").modal();
    }, 100);
  }
}

PreferencesController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "events",
  "profile",
  "companies",
  "security",
  "$rootScope",
  "common",
  "env",
  "$timeout",
  "$location",
  "$scope",
];

export default PreferencesController;



// WEBPACK FOOTER //
// ./client/app/components/jobbler/preferences/preferences.controller.js